import React from 'react';

import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';

import {useTenantInfo} from 'modules/tenant/hooks';
import {formatAxiosErrorOrThrow} from 'shared/utils/error';
import {createUserFromSignupPage} from 'modules/user/api/user';
import { TeacherSignupForm } from 'shared/pages/Signup/TeacherSignup/TeacherSignupForm';
import { ISignupPageSummary } from 'modules/signup-page/models';

import {FullScreenModal} from 'shared/components/FullScreenModal/FullScreenModal';
import {FullScreenModalTitle} from 'shared/components/FullScreenModal/FullScreenModalTitle';
import {ICreateUserForm} from 'users/pages/CreateUser/CreateUser';

import '../styles.scss';

interface ITeacherFreeSignupProps {
    signupPageSummary: ISignupPageSummary;
}

export const TeacherFreeSignup = ({signupPageSummary}: ITeacherFreeSignupProps) => {
    const {t} = useTranslation();
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

    const {tenantInfo} = useTenantInfo();

    const navigate = useNavigate();

    const onSubmit = ({role, ...userCreate}: ICreateUserForm) => {
        if (isSubmitting) {
            return;
        }
        setIsSubmitting(true);
        (async () => {
            try {
                await createUserFromSignupPage(
                    tenantInfo.id,
                    signupPageSummary.id,
                    {
                        roles: [role],
                        ...userCreate,
                    },
                );
                // redirect to login page
                navigate('/login');
                toast.success(t('signup.success', 'Signup successful! Please login'));
            } catch (e) {
                toast.error(formatAxiosErrorOrThrow(t(
                    'signup.submit.error', 'There was an error',
                ), e));
            } finally {
                setIsSubmitting(false);
            }
        })();
    };

    return (
        <FullScreenModal close={false} size="md">
            <FullScreenModalTitle className="mb-4">
                {tenantInfo.name === 'Demo' || 'test' ? (
                    t('common.teacherSignup.title', 'Sign up to Young Eyes as a teacher')
                ) : (
                    t('common.teacherSignup.title', 'Sign up to Young Eyes {{tenantName}} as a teacher', {tenantName: tenantInfo.name})
                )}
            </FullScreenModalTitle>
            <TeacherSignupForm
                onGoBack={() => navigate(-1)}
                isSubmitting={isSubmitting}
                onSubmit={onSubmit}
            />
        </FullScreenModal>
    );
};